/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExcelColumn,
    ExcelColumnFromJSON,
    ExcelColumnFromJSONTyped,
    ExcelColumnToJSON,
    FailureStatusFilter,
    FailureStatusFilterFromJSON,
    FailureStatusFilterFromJSONTyped,
    FailureStatusFilterToJSON,
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAllFailuresExcelQuery
 */
export interface GetAllFailuresExcelQuery {
    /**
     * 
     * @type {FailureStatusFilter}
     * @memberof GetAllFailuresExcelQuery
     */
    statusFilter?: FailureStatusFilter;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllFailuresExcelQuery
     */
    onlyNotAssignedToRepairman?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAllFailuresExcelQuery
     */
    timeZone?: string | null;
    /**
     * 
     * @type {Array<ExcelColumn>}
     * @memberof GetAllFailuresExcelQuery
     */
    columns?: Array<ExcelColumn> | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresExcelQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresExcelQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresExcelQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresExcelQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetAllFailuresExcelQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAllFailuresExcelQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetAllFailuresExcelQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetAllFailuresExcelQueryFromJSON(json: any): GetAllFailuresExcelQuery {
    return GetAllFailuresExcelQueryFromJSONTyped(json, false);
}

export function GetAllFailuresExcelQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllFailuresExcelQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusFilter': !exists(json, 'statusFilter') ? undefined : FailureStatusFilterFromJSON(json['statusFilter']),
        'onlyNotAssignedToRepairman': !exists(json, 'onlyNotAssignedToRepairman') ? undefined : json['onlyNotAssignedToRepairman'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'columns': !exists(json, 'columns') ? undefined : (json['columns'] === null ? null : (json['columns'] as Array<any>).map(ExcelColumnFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetAllFailuresExcelQueryToJSON(value?: GetAllFailuresExcelQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusFilter': FailureStatusFilterToJSON(value.statusFilter),
        'onlyNotAssignedToRepairman': value.onlyNotAssignedToRepairman,
        'timeZone': value.timeZone,
        'columns': value.columns === undefined ? undefined : (value.columns === null ? null : (value.columns as Array<any>).map(ExcelColumnToJSON)),
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


